export const arrowUpIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.421 11.765 13.768.8A2.64 2.64 0 0 0 12 0a2.65 2.65 0 0 0-1.768.8L.579 11.765A1.413 1.413 0 1 0 2.7 13.632l7.45-8.466a.25.25 0 0 1 .437.166v17.255a1.413 1.413 0 1 0 2.826 0V5.332a.25.25 0 0 1 .438-.165l7.449 8.465a1.413 1.413 0 1 0 2.121-1.867"/></svg>`,
    name: 'arrow-up'
};